import { useFormContext } from "react-hook-form";
import { TransactionTypeSelect } from "@/components/fields/transaction-type-select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

interface FormTransactionTypeSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  grouped?: boolean;
}

export function FormTransactionTypeSelect({
  name,
  label,
  placeholder,
  required,
  disabled,
  grouped,
}: FormTransactionTypeSelectProps) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel required={required}>{label}</FormLabel>}
          <FormControl>
            <TransactionTypeSelect
              value={field.value?.toString() ?? ""}
              onChange={field.onChange}
              placeholder={placeholder}
              disabled={disabled}
              grouped={grouped}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
